const { cELM } = require("../utils");

class Notification {
  constructor(options) {}

  // type: ['error', 'warning', 'status']
  static show(value, type = "status") {
    const pbar = document.getElementsByClassName("progress-bar")[0];
    Notification.clear();

    const _el = cELM("div", "notification " + type + "-notification notification-active", value);
    pbar.parentNode.insertBefore(_el, pbar.nextSibling);
  }

  static timeoutShow(value, type = "status", timeout = 3000) {
    Notification.show(value, type);
    setTimeout(() => {
      Notification.clear();
    }, timeout);
  }

  static clear() {
    const parent = document.getElementsByClassName("main")[0];
    const notifications = document.getElementsByClassName("notification");
    for (let i = 0; i < notifications.length; i++) {
      parent.removeChild(notifications[i]);
    }
  }
}

module.exports = Notification;
